module.exports = __webpack_public_path__ + "static/img/5.aacbd64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/zh/5.png
// module id = /WkL
// module chunks = 0